<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :filterOfZones="true"
              :filterOfSubZones="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classZones="col-12 col-md-6 col-xl-3"
              classSubZones="col-12 col-md-6 col-xl-3"
              :classFarms="`col-12 col-sm-12 col-md-6 ${
                isInspectionForLot ? 'col-lg-3 col-xl-3' : 'col-lg-4 col-xl-4'
              }`"
              :classLots="`col-12 col-sm-12 col-md-6 ${
                isInspectionForLot ? 'col-lg-3 col-xl-3' : 'col-lg-4 col-xl-4'
              }`"
            >
              <template slot="prev">
                <div :class="`col-12 col-md-6 col-xl-3 mt-3`">
                  <label>{{ $t('common_words.evaluations') }}: * </label>
                  <br />
                  <el-select
                    @change="isEvaluationTypeFarm(evaluation_id)"
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-evaluation_id"
                    v-model="evaluation_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in evaluations"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div :class="`col-12 col-md-6 col-xl-3 mt-3`">
                  <label for="">{{ $t('audit.subcategories') }}: * </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('subcategory_ids', subcategories)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    multiple
                    class="select-primary custom-width-select shadow-sm required-subcategories_id"
                    v-model="subcategory_ids"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in subcategories"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template slot="after-lot">
                <div
                  :class="`col-12 col-sm-12 col-md-6 mt-3 ${
                    isInspectionForLot
                      ? 'col-lg-3 col-xl-3'
                      : 'col-lg-4 col-xl-4'
                  }`"
                >
                  <label for="">{{ $t('audit.calculate_na') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-calculation_type_NA"
                    v-model="calculation_type_NA"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in getCalculationTypeNA"
                      :key="item.id + item.label"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="isInspectionForLot"
                  :class="`col-12 col-sm-12 col-md-6 mt-3 ${
                    isInspectionForLot
                      ? 'col-lg-3 col-xl-3'
                      : 'col-lg-4 col-xl-4'
                  }`"
                >
                  <label for="">{{ $t('audit.calculation_type') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-calculation_type"
                    v-model="calculation_type"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in getCalculationType"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <div v-if="haveData">
          <card>
            <div class="row">
              <div class="col-12">
                <highcharts :options="actualChart"></highcharts>
              </div>
            </div>
          </card>
          <card>
            <div class="custom-scroll-table-wrapper">
              <table class="table table-striped table-bordered mt-3 mb-5">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label sticky-header"
                      style="min-width: 85px"
                    >
                      {{ $t('common_words.years') }}
                    </th>
                    <th
                      v-for="(week, indexWeeks) in tableData.table
                        .all_weeks_of_year"
                      :key="'header-week-' + indexWeeks"
                      class="text-center p-3 custom-header-label sticky-header"
                      style="min-width: 85px"
                    >
                      {{ week }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(year, indexYears) in tableData.table.years"
                    :key="'row-' + indexYears"
                  >
                    <td class="text-center p-3">{{ year }}</td>
                    <td
                      v-for="(value, indexWeek) in tableData.table
                        .all_weeks_of_year_with_values[indexYears]"
                      :key="'cell-' + indexYears + '-' + indexWeek"
                      class="text-center p-3"
                    >
                      {{ value !== null ? value : '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </card>
        </div>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { isset } from 'src/util/Util.js';
import { validateDateRangeByFilterComponentByYear } from 'src/util/Util';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
export default {
  components: {
    highcharts: Chart,
    [Filter.name]: Filter,
  },
  mixins: [MixinMasters, MixinMenu, MixinPermissions, MixinCharts],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  data() {
    return {
      valueCollapse: null,
      activeName: 'filter',
      evaluations: [],
      subcategory_ids: [],
      evaluation_id: null,
      calculation_type_NA: 'Sin NA',
      calculation_type: 0,
      data_export: null,
      model: {},
      isInspectionForLot: false,
      inspections: [],
      subcategories: [],
      haveData: false,
      actualChart: [],
    };
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getCalculationType() {
      return [
        { id: 0, value: 'withoutArea', name: i18n.t('audit.without_lot_area') },
        { id: 1, value: 'withArea', name: i18n.t('audit.with_lot_area') },
      ];
    },
    getCalculationTypeNA() {
      return [
        {
          id: 0,
          value: 'Sin NA',
          label: i18n.t('audit.calculation_without_na'),
        },
        { id: 1, value: 'Con NA', label: i18n.t('audit.calculation_with_na') },
      ];
    },
  },
  methods: {
    getSelectAll() {
      this.subcategories = this.concatAll(this.subcategories.splice(1));
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    isEvaluationTypeFarm(evaluationId) {
      if (isset(this.evaluation_id)) {
        this.subcategory_ids = [];
        const evaluationSelect = this.evaluations.find(
          (evaluation) => evaluation.id == evaluationId
        );
        this.subcategories = this.concatAll(evaluationSelect.sub_categories);
        this.showCalculationTypeSelect =
          evaluationSelect && evaluationSelect.catch_type === '1';
        if (evaluationSelect.catch_type === '1') {
          this.isInspectionForLot = true;
        } else {
          this.calculation_type = 0;
          this.isInspectionForLot = false;
        }
      } else {
        this.subcategory_ids = [];
        this.subcategories = [];
        this.isInspectionForLot = false;
      }
    },
    handleFilter(data) {
      this.dataFilter = { ...data };
      if (!isset(this.evaluation_id)) {
        return this.validationInputsRequired('evaluation_id');
      } else if (!isset(this.subcategory_ids)) {
        return this.validationInputsRequired('subcategories_id');
      } else if (!isset(this.calculation_type_NA)) {
        return this.validationInputsRequired('calculation_type_NA');
      } else if (!isset(this.calculation_type)) {
        return this.validationInputsRequired('calculation_type');
      }
      const { datei, datef, bySel } = this.dataFilter;
      const validRangeDate = validateDateRangeByFilterComponentByYear(
        datei,
        datef,
        bySel,
        3
      );
      if (validRangeDate) {
        this.getData();
      } else {
        this.haveData = false;
        SweetAlert.warning(i18n.t('sweet_alert.common.date_range_error'));
      }
    },
    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      this.haveData = false;
      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.evaluation_id = this.evaluation_id;
      data.calculation_type = this.calculation_type;
      data.calculation_type_NA = this.calculation_type_NA;
      data.subcategory_ids = this.subcategory_ids;
      data.route = 'advanced/audits/trendchart';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.haveData = false;
          } else {
            this.haveData = true;
            this.actualChart = this.lines(
              this.tableData.line_chart,
              true,
              'auto',
              false,
              true
            );
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      Axios.getMasters('advanced/audits/inspectionswithsubcategories').then(
        (response_inspections) => {
          this.evaluations = response_inspections.data.data;
          this.showHideLoading();
        }
      );
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('advanced');
  },
  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #898989;
}
.custom-scroll-table-wrapper table {
  min-width: 700px;
  border-collapse: collapse;
}
.bg-total-row {
  background-color: #898989 !important;
  color: white !important;
}
.bg-total-row td {
  font-weight: bold !important;
}
</style>
